'use client'

import StarIcon from '@/assets/icons/star-icon.svg'
import { useTranslations } from 'next-intl'

type Props = {
  totalStars?: number
  rating: number
  onChange?: (rate: number) => void
  changeable?: boolean
  size?: 'small' | 'medium' | 'large'
}

export const Stars: React.FC<Props> = ({
  totalStars = 5,
  rating,
  onChange,
  changeable,
  size = 'small',
}) => {
  const t = useTranslations()
  const handleStarClick = (index: number) => {
    onChange?.(index + 1)
  }
  const sizeClass = {
    small: 'h-4 w-4',
    medium: 'h-6 w-6',
    large: 'h-8 w-8',
  }

  return (
    <div className='flex items-center gap-2'>
      {[...Array(totalStars)].map((_, index) => (
        <button
          key={index}
          type='button'
          onClick={() => handleStarClick(index)}
          aria-label={t('ariaLabels.rate', { rate: index + 1 })}
          className={`${
            index < rating ? 'text-gold' : 'text-amber-200'
          } focus:outline-none ${changeable ? 'cursor-pointer' : 'cursor-text'}`}
        >
          <StarIcon className={sizeClass[size]} aria-hidden='true' />
        </button>
      ))}
    </div>
  )
}
